import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { updateDb } from "../services/updateDb";
import { useAppContext } from "../AppContext";

function ArchiveRiskModal({ riskObj, show, setRefreshData, onArchived, silent }) {
  const { t } = useTranslation();
  const { showAlertMessage, closeModal } = useAppContext();
  const [reason, setReason] = useState("");
  const [error, setError] = useState(null);
  const [isSaving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setReason("");
      setError(null);
      setSaving(false);
    }
  }, [show, riskObj]);

  const archive = async () => {
    if (!reason.trim()) {
      setError(t("archive_reason_required"));
      return;
    }

    setSaving(true);
    const res = await updateDb("/api/risks/archive/" + riskObj.id, { reason: reason.trim() });
    setSaving(false);

    if (!res.success) {
      setError(res.error);
      return;
    }

    setRefreshData(new Date().getTime());
    if (!silent) showAlertMessage("success", t("risk_archived"));
    closeModal();
    if (typeof onArchived === "function") onArchived(riskObj.id);
  };

  if (!riskObj?.id) return null;

  return (
    <Modal show={show} onHide={closeModal}>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>{t("archive_risk")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ fontWeight: 600, marginBottom: 8 }}>{riskObj.description}</p>
        <p style={{ opacity: 0.8, fontSize: 14 }}>{t("archive_risk_text")}</p>
        <Form.Group controlId="archiveReason">
          <Form.Label><b>{t("archive_reason")}</b></Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            maxLength={1000}
            value={reason}
            placeholder={t("archive_reason_placeholder")}
            onChange={(e) => { setReason(e.target.value); setError(null); }}
            autoFocus
          />
        </Form.Group>
        {error && <div style={{ color: "var(--red-risk-score)", marginTop: 8, fontSize: 14 }}>{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <div className="white-border-btn cancel-btn" onClick={closeModal}>{t("cancel")}</div>
        <div style={{ flexGrow: 1 }} />
        <div
          className="white-border-btn delete-btn"
          onClick={isSaving ? undefined : archive}
          style={isSaving ? { opacity: 0.6, cursor: "not-allowed" } : undefined}
        >
          <i className="icon-archive" />&nbsp;{t("archive_risk")}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ArchiveRiskModal;
